import React from "react";

const ArrowRightIcon = props => (
  <svg
    width="26px"
    height="24px"
    viewBox="0 0 26 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Arrow pointing right</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="arrow-right-icon"
        transform="translate(-12.000000, -12.000000)"
        stroke="#363636"
        strokeWidth="2"
      >
        <g
          id="Group"
          transform="translate(24.000000, 24.000000) rotate(-90.000000) translate(-24.000000, -24.000000) translate(13.000000, 12.000000)"
        >
          <polyline id="Line" points="0 13 11 24 22 13" />
          <path d="M11,0 L11,24" id="Line" />
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowRightIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowRightIcon.js